import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

export interface SessionDto {
  id: string;
  device: string;
  ipAddress?: string;
  createdAt: string;
  expiresAt?: string;
  isRevoked: boolean;
  isActive: boolean;
}

@Injectable({ providedIn: 'root' })
export class SessionsService {
  constructor(private api: ApiService) {}

  mySessions() {
    return this.api.get<SessionDto[]>('/api/sessions/me');
  }

  revokeMine(sessionId: string) {
    return this.api.post<void>('/api/sessions/me/revoke', { sessionId });
  }

  revokeAllMine() {
    return this.api.post<void>('/api/sessions/me/revoke-all', {});
  }

  heartbeat(sessionId: string) {
    return this.api.post<{ sessionId: string, expiresAt?: string }>('/api/sessions/heartbeat', { sessionId });
  }
}
